module.exports = __webpack_public_path__ + "img/POP-00011-2.3297fadc.png";